const orderApiList = {
  orderList: "/manage/order/order/list", // 订单列表
  orderListDetail: "/manage/order/order/listDetail", // 订单table详情
  acceptOrder: "/manage/order/order/acceptOrder", // 接单备货
  pareDone: "/manage/order/order/pareDone", // 备货完成
  cancelPare: "/manage/order/order/cancelPare", // 取消备货
  bigorderCancelPare: "/special/order/cancelStockPile", // 大单取消备货
  outWare: "/manage/order/order/outWare", // 备货出库
  outWareJgj: "/v3/manage/order/outWare", // 紧固件确定出库
  bigorderOutWare: "/special/order/outWareHouse ", // 大单 备货出库
  updatePack: "/manage/order/order/updatePack", // 更新打包箱数和称重
  listBox: "/manage/order/order/listBox", // 箱号详情
  getOrderDetail: "/manage/order/order/get", // 获取订单form详情
  refuseOrder: "/manage/order/order/refuseOrder", // 拒单
  jgjRefuseOrder: "/v3/manage/order/refuseOrder", // 紧固件的拒单
  getOrder: "/manage/order/order/get", // 获取单个子订单
  getWrongOrder: "/manage/order/order/getWrong", // 获取拒单子订单
  listOrderWithBox: "/manage/order/order/listOrderWithBox", // 获取扫描的订单
  scanAction: "/manage/order/order/scan", // 扫描
  listOutWare: "/manage/order/order/listOutWare", // 获取当天出库清单
  orderShippingList: "/manage/order/order/shippingList", // 发货清单
  stockListing: "/manage/order/order/stockListing", // 备货清单
  bigorderStockListing: "/special/order/stockPileList", // 大单 备货清单
  listWrongDetail: "/manage/order/order/listWrongDetail", // 拒单列表
  shippingListLogistics: "/manage/order/order/shippingListLogistics", // 直发面单
  printLogisticsSheet: "/manage/order/order/batchNoticeLogistics", // 通知物流取货
  printOneBox: "/manage/order/order/printOneBox", // 补打箱码
  getTraceStandalone: "/manage/order/order/getTraceStandalone", // 物流明细
  exporOrdertData: "/manage/order/order/downloadOrder", // 导出三方订单
  autoPareDone: "/manage/order/order/batchAutoDone", // 自动备货完成
  cancelOrderDialogData: "/manage/order/order/checkCancelOrder", // 检查取消订单
  getPurchaseList: "/v2/web/order/getPurchaseList", // 获取采购订单
  printPurchaseList: "/v2/web/order/printPurchase", // 打印采购订单
  getOutStockDetail: "/v2/web/order/getOutStockDetail", // 打印采购订单
  getTransportDetail: "/v2/web/order/getTransportDetail", // 获取快递子单号详情
  getOrderListForChangeBoxNum: "/v2/web/order/getOrderListForChangeBoxNum", // 更改箱码数量时获取订单列表
  saveBatchChangeBoxNum: "/v2/web/order/saveBatchChangeBoxNum", // 保存批量修改的箱码数量
  batchExportGoodsDetail: "/v2/web/order/batchExportGoodsDetail", // 批量导出货物清单
  bigorderBatchExportGoodsDetail: "/special/order/importStockPileList", // 大单 批量导出货物清单
  batchPrintBoxCode: "/v2/web/order/batchPrintBoxCode", // 批量打印箱码
  clearBatchChangeBoxNum: "/v2/web/order/clearBatchChangeBoxNum", // 清空打包数量和箱码
  getFactoryOrderList: "/v2/web/order/getOrderList", // 获取订单列表 工厂
  getnoArrivedOrder: "/v2/web/order/getOutWareByTimeOut", // 获取未到分仓订单
  orderGoodsDetail: "/v2/web/order/getOrderGoodsDetail", // 获取物流运单商品列表
  queryOrderTotalnum: "/system/order/totalnum", // 获取订单各种总数
  r4MatchRefuseList: "/v3/manage/order/getRefuseOrderList", // R4 自配拒单列表
  r4MatchRefuseLisDetail: "/v3/manage/order/getRefuseOrderInfo", // R4 自配拒单详情
  r4MatchRefuseOrderSure: "/v3/manage/order/confirmRefuseOrderInfo", // R4 自配拒单确认
  getBoxStatus: "/system/order/boxstatusenum", //物流状态枚举
  getNewList: "/system/order/list", //订单列表（直发|工厂专用）
  getBoxList: "/system/order/boxlist", //订单物流包裹
  getPackagetrace: "/system/transport/packagetrace", //包裹对应物流轨迹
  getShipStatusEnum: "/system/order/ordershippingdelaystatusenum" //报备状态
};
export default orderApiList;



// WEBPACK FOOTER //
// ./src/service/basic/orderApiList.js